import React from 'react';
import { Typography } from '@material-ui/core';

import { Section } from 'components/Section';
import { Company } from 'libs/api/invest/generated/schema';

import { MappedSection } from '../../dashboardSettingsTypes';
import { getValue } from '../../dashboardSettingsUtils';
import './styles.scss';


export function CompanyInfo(
  props: { company: Company, section: MappedSection }
) {
  return (
    <Section>
      <div className="bg-white d-flex align-items-center p-2 w-100 m-2 lens-ml-0 lens-pl-0">
        <div className="d-flex flex-column w-100">
          <div className="companyTitle d-flex flex-row align-items-center lens-company-title">
            <div
              className={`info-${props.company.investmentsStatus === 'A_10' ? 'active' : 'inactive'}`}
            />
            <Typography variant="h2" className="pl-2 font-weight-bold lens-pl-0">
              {props.company.name}
            </Typography>
            {props.company.currency !== props.company.rawCurrency &&
              <span
                className="badge badge-dark ml-3 currency-sign"
                style={{ fontSize: '96%' }}
              >
                {window.GLOBAL_CONFIG.CURRENCIES[props.company.rawCurrency || '']?.sign}
              </span>
            }
          </div>
          <div className="row">
            <div className="col-sm-3">
              <div className="companyLogo">
                {props.company.logo ? (
                  <img
                    style={{ maxWidth: '100%', height: 'auto' }}
                    src={props.company.logo}
                  />
                ) : (
                  <img
                    width="210"
                    height="105"
                    src="/static/images/company_defaultlogo.svg"
                  />
                )}
              </div>
            </div>
            <div className="col-sm-9">
              <div className="d-flex flex-column companyInfo">
                <div className="d-flex">
                  <div className="d-flex flex-row flex-wrap">
                    {props.section.components
                      .filter((
                        c) => c.name === 'partner' ? Boolean(getValue(c, props.company)) : c.checked
                      )
                      .map((component, i: number) => (
                        <div key={i} className="d-flex flex-column componentBox">
                          <Typography className="p-1 labelTitle text-uppercase">
                            {component.label}
                          </Typography>
                          {component.name === 'website'
                            ? <a href={getValue(component, props.company)}>{getValue(component, props.company)}</a>
                            : <Typography className="labelValue">{getValue(component, props.company)}</Typography>
                          }
                          {component.name === 'name' && props.company.investmentsStatus !== 'A_10' && (
                            <div className="mb-3">
                              <strong>{props.company.investmentsStatusDisplay}</strong>
                              {props.company.investmentsStatus === 'A_50' && (
                                <Typography>
                                  Name: {props.company.ipoName === null
                                    ? 'N/A'
                                    : props.company.ipoName
                                  }
                                </Typography>
                              )}
                              {props.company.investmentsStatus !== null && (
                                <Typography>
                                  Date: {props.company.inactivityDate?.format('MMM D, YYYY') || 'N/A'}
                                </Typography>
                              )}
                              {(
                                props.company.investmentsStatus === 'A_40'
                                || props.company.investmentsStatus === 'A_50'
                              ) && (
                                  <Typography>
                                    {props.company.aggregationType
                                      ? 'Share Price: '
                                      : 'Average share price: '
                                    }
                                    {props.company.sharePrice === null
                                      ? 'N/A'
                                      : `${window.GLOBAL_CONFIG.CURRENCIES[props.company.currency].sign}${props.company.sharePrice}`
                                    }
                                  </Typography>
                                )}
                              {(
                                props.company.investmentsStatus === 'A_40'
                                || props.company.investmentsStatus === 'A_50'
                              ) && (
                                  <Typography>
                                    Redeemed Shares: {props.company.redeemedShares === null
                                      ? 'N/A'
                                      : props.company.redeemedShares
                                    }
                                  </Typography>
                                )}
                              {props.company.investmentsStatus !== null && (
                                <Typography>
                                  Proceeds: {props.company.totalProceeds === null
                                    ? 'N/A'
                                    : `${window.GLOBAL_CONFIG.CURRENCIES[props.company.currency].sign}${props.company.totalProceeds}`
                                  }
                                </Typography>
                              )}
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}
